<template>
  <div class="record-search" v-loading="loading" element-loading-text="拼命加载中">
    <div class="headLine">
      <img src="../leftAngle.png" alt="返回上一层" @click="backIndex"/>
      危险化学品使用记录
    </div>
    <div class="search-input">
      <div class="search-select">
        <el-input v-model="key" placeholder="请输入药品ID/名称/编码"/>
      </div>
      <div class="search-btn">
        <button class="btn btn-left" @click="clear">清除内容</button>
        <button class="btn btn-right" @click.prevent="searchRecord(1)">查询记录</button>
      </div>
    </div>

    <div class="search-result warpper" ref="wrapper">
      <ul class="result-content content">
        <li class="result-item"
          v-for="(item, index) in recordList"
          :key="index"
        >
          <div class="item-name">记录编号：{{item.id}}</div>
          <div class="item-inventory">创建时间：{{item.createTime}}</div>
          <div class="item-inventory">经办人：{{item.handleUser}}</div>
          <div class="item-inventory">确认人：{{item.confirmUser}}</div>
          <div class="item-use">生产部经理：{{item.managerName}}</div>
<!--          <div class="item-inAndOut">-->
<!--            进出库：-->
<!--            <el-tag v-if="item.type === 0" type="danger">出库</el-tag>-->
<!--            <el-tag v-else-if="item.type === 1" type="danger">入库</el-tag>-->
<!--          </div>-->
          <div class="item-state">
            状态：
            <el-tag v-if="item.status === -1" type="info">未通过审核</el-tag>
            <el-tag v-else-if="item.status === -1">未通过审核</el-tag>
            <el-tag v-else-if="item.status === 0 && !item.managerId">待审核</el-tag>
            <el-tag v-else-if="item.status === 0 && item.managerId">待生产部经理审核</el-tag>
            <el-tag v-else-if="item.status === 1" type="danger">已完成</el-tag>
          </div>
          <div class="item-btn">
            <el-button class="btn btn-left" @click="detail(item.id)">详情</el-button>
            <el-button class="btn btn-right" @click="dialogCheck(item.id)">审核</el-button>
          </div>
<!--          <div class="item-btn">-->
<!--            <el-button class="btn btn-bottom" disabled @click="check">重新提交审核</el-button>-->
<!--          </div>-->
        </li>
      </ul>
    </div>
    <!-- 第一次审核 -->
    <el-dialog
      title="审核"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :show-close="false"
      class="overDialog"
      :before-close="handleClose"
    >
      <div class="dialogBlock">
        <el-form
          :model="checkForm"
          ref="checkForm"
          :rules="rules"
          label-width="100px"
          label-position="right"
        >
          <el-form-item label="仓管员：" prop="warehouseKeeper">
            <el-input v-model="checkForm.warehouseKeeper" readonly />
          </el-form-item>
          <el-form-item label="是否同意：" prop="pass">
            <el-radio-group v-model="checkForm.pass">
              <el-radio :label="true">同意</el-radio>
              <el-radio :label="false">不同意</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注：" prop="checkReason">
            <el-input v-model="checkForm.checkReason" type="textarea" rows="8" />
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="check" :loading="submitBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BScroll from 'better-scroll'

export default {
  data() {
    return {
      popstateLock: 0,//是否监听物理返回键
      loading: false,
      page: 1, // 分页查询，第一次为1
      pullupMsg: '加载更多',
      isShowTips: false,
      visible: false,
      key: null,
      recordList:[],
      keyword: null,
      nowCheckId: 0,
      submitBtn: false,
      checkForm: {
        checkReason: "",
        pass: true,
        warehouseKeeper: "",
        warehouseKeeperId: 0
      },
      rules: {
        pass: [
          {required: true, message: '是否通过必须选择', trigger: 'blur'}
        ],
      }
    };
  },
  created() {
    this.searchRecord(0);
  },
  watch: {
    popstateLock(val) {
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val) {
        this.addPopstate()
      } else {
        this.removePopstate()
      }
    }
  },
  destroyed() {
    this.removePopstate()
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
    this.$nextTick(() => {
      this._initBScroll()
    })
  },
  methods: {
    addPopstate() {
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate() {
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 返回上一层
    backIndex() {
      this.$router.replace({name: 'hyWarehousePage'})
    },
    handleClose() {
      this.visible = false;
    },
    //详情
    detail(id) {
      this.$router.replace({
        name: 'medicineRecordEdit',
        query: {
          id: id,
          isCreate: false,
          isView: true
        }
      })
    },
    dialogCheck(id) {
      this.visible = true;
      this.checkForm.checkReason = null;
      this.checkForm.pass = true;
      this.nowCheckId = id;
    },
    //审核
    check() {
      this.submitBtn = true;
      // 要先通过判断
      this.$refs.checkForm.validate((valid) => {
        if (valid) {
          this.$http.httpPost(`/app/laMedicineUseRecord/check`, {
            "checkReason": this.checkForm.checkReason,
            "id": this.nowCheckId,
            "pass": this.checkForm.pass,
          }).then(res => {
            if (res.code === 0 && res.msg === 'success') {
              this.submitBtn = false;
              this.$message({
                message: `审核成功`,
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                }
              })
            } else {
              this.$message.error(res.msg)
              this.submitBtn = false;
              this.searchRecord(1);
            }
          })
        } else {
          this.$message.error('校验不通过')
          this.submitBtn = false;
        }
      })
    },
    clear() {
      if (this.key) {
        this.key = null;
        this.searchRecord(0);
      }
    },
    searchRecord(valPost) {
      this.page = 1;
      let getKey = this.$route.query.key;
      let theKey = null;
      if (valPost === 0) {
        if (getKey) {
          theKey = getKey;
          this.key = getKey;
        } else {
          theKey = null;
          this.key = null;
        }
      } else {
          theKey = this.key;
      }
      this.$http.httpGet('/app/laMedicineUseRecord/list', {
        key: theKey,
        page: 1,
        limit: 10
      }).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          if (res.page.list.length == 0) {
            this.$message.info('查无记录')
          }
          this.recordList = res.page.list
          this.page++
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    _initBScroll() {
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.wrapper, {
          //开启点击事件 默认为false
          click: true,
          scrollY: true,
          probeType: 3
        })
        // 一些监听
        this.scroll.on('scroll', (pos) => {
          if (pos.y - this.scroll.maxScrollY < -50) {
            this.isShowTips = true
          } else {
            this.isShowTips = false
          }
        })

        this.scroll.on('touchEnd', pos => {
          // 1.2.1监听下拉
          if (pos.y >= 50) {
            console.log('下拉刷新')
          }
          // 1.2.2监听上拉
          if (this.scroll.maxScrollY > pos.y + 50) {
            this.loading = true
            this.$http.httpGet('/app/laMedicineWarehouseRecord/list', {
              key: this.key,
              page: this.page,
              limit: 10
            }).then(res => {
              this.loading = false
              if (res.code === 0 && res.msg === 'success') {
                if (res.page.list.length == 0) {
                  this.$message.info('没有更多数据了')
                  return
                }
                this.page++
                let arr = res.page.list
                this.recordList = this.recordList.concat(arr)
                this.$nextTick(() => {
                  this.scroll.refresh()
                  this.scroll.finishPullUp()
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      } else if (!this.$refs.wrapper) {
        return
      } else {
        this.scroll.refresh()
      }
    },
  },

}
</script>

<style scoped lang="scss">
//@import '@/assets/style/global.scss';
.record-search {
  margin: 0;
  padding: 50px 0 0;
  position: relative;
  width: 100%;

  .headLine {
    height: 50px;
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 9;
    font-size: 16px;
    border-bottom: 1px #efefef solid;

    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .search-input {
    position: relative;
    margin: 10px 0 20px;
    overflow: hidden;
    .search-select {
    display: flex;
    justify-content: space-between;
    text-align: center;
    padding: 0 20px 10px;

    .el-select {
        width: 100%;
    }
    }

    .search-btn {
      margin-top: 0;
      padding: 0 20px;

      button {
        height: 3.2rem;
        font-weight: 700;
        display: inline-block;
        width: 40%;
      }

      .btn-left {
        float: left;
        width: 48%;
        background-color: rgb(207, 0, 0);
      }

      .btn-right {
        float: right;
        width: 48%;
        background-color: rgb(6, 175, 6);
      }
    }
  }

  .search-result {
    position: relative;
    padding: 0;
    height: calc(100vh - 50px - 120px);
    width: 100%;
    // height: 100%;
    overflow: hidden;

    .result-content {
      padding: 0 20px 10px;

      .result-item {
        position: relative;
        box-sizing: border-box;
        padding: 10px 10px 10px;
        border-radius: 0.5rem;
        margin-top: 1.6rem;
        /*height: 12rem;*/
        background-color: #f2f6fc;
        color: #303133;
        font-size: 1.6rem;
        box-shadow: 0 0.3rem 0.5rem #eee;

        .item-name,
        .item-inventory,
        .item-use{
          position: relative;
          margin-bottom: 5px;
          height: 2rem;
          text-align: left;
          line-height: 2rem;
          font-size: 1.4rem;
          color: #000;
        }
        .item-inAndOut,
        .item-state {
          position: relative;
          margin-bottom: 5px;
          height: 3rem;
          text-align: left;
          line-height: 3rem;
          font-size: 1.4rem;
          color: #000;
        }

        .item-btn {
          position: relative;
          margin-bottom: 25px;
          height: 2rem;
          line-height: 2rem;
          font-size: 1.4rem;
          color: #000;

          button {
            height: 3.2rem;
            font-weight: 700;
            display: inline-block;
            width: 48%;
            background-color: #3A9DF2;
          }
          .btn-left {
            float: left;
          }
          .btn-right {
            float: right;
            background-color: rgba(144,147,153,1);
          }
          .btn-bottom {
            width: 98%;
            background-color: rgba(245,108,108,1);
          }
        }
      }
    }
  }
  .bottom-tip {
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: #333;
    // background: #f2f2f2;
    position: absolute;
    bottom: -5px;
    font-size: 1.6rem;
    left: 0;
  }
}

::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #666;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.el-select-dropdown__item {
  font-size: 14px !important;
  line-height: 34px;
  padding: 0 20px;
}

.overDialog::v-deep {
  .el-dialog {
    margin: 0 !important;
    width: 100%;
    .el-dialog__header {
      padding: 15px;
      border-bottom: 1px #efefef solid;
      span {
        text-align: center;
        font-size: 16px;
        display: block;
      }
    }
    .el-dialog__footer {
      padding: 15px;
      border-top: 1px #efefef solid;
      .el-button {
        width: 49%;
        &+.el-button {
          margin: 0 0 0 2%;
        }
      }
    }
    .el-dialog__body {
      height: calc(100vh - 55px - 71px - 30px);
      padding: 15px;
      .postBlock {
        margin: 0 0 15px;
        position: relative;
        .postList {
          position: relative;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          .postName {
            width: 90px;
            font-size: 14px;
            letter-spacing: 1px;
            text-align: right;
            line-height: 1.8;
          }
          .postValue {
            flex: 1;
            font-size: 14px;
            letter-spacing: 1px;
            line-height: 1.8;
            .el-input-number {
              width: 100%;
            }
          }
        }
      }
      .holdPart {
        position: relative;
        .postList {
          position: relative;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          .postName {
            width: 90px;
            font-size: 14px;
            letter-spacing: 1px;
            text-align: right;
            line-height: 1.8;
          }
          .postValue {
            flex: 1;
            font-size: 14px;
            letter-spacing: 1px;
            line-height: 1.8;
            .el-input-number {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
